/*
 * @Date: 2022-07-04 17:19:59
 * @LastEditors: chuhongguang
 * @desc: 页面Html框架（底部导航栏）
 */
export default {
  print:'Print Page',
  contact:'Contact Us'
}